import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p401342260258422784',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
